import * as React from 'react';
import styled from 'styled-components';
import { noop } from 'lodash';
import * as grid from 'view/styles/grid';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';
import { SPINNER_DELAY } from '@atlassian/help-center-common-component/constants';
import { SPINNER_SIZE } from './styled';

interface LoadingProps {
    className?: string;
    isRelative?: boolean;
}

class LoadingResult extends React.PureComponent<LoadingProps> {
    render() {
        return (
            <LoadingRoot {...this.props} data-test-id="search-results-loader">
                <Spinner
                    delay={SPINNER_DELAY}
                    invertColor={false}
                    onComplete={noop}
                    size={SPINNER_SIZE.unitless}
                    isCompleting={false}
                />
            </LoadingRoot>
        );
    }
}

export default LoadingResult;

const loadingRootLeft = `calc(50% - ${SPINNER_SIZE.multiple(0.5).px})`;

const LoadingRoot = styled.div<{ isRelative?: boolean }>`
    left: ${loadingRootLeft};
    top: ${(props) => (props.isRelative ? token('space.200', '16px') : grid.multiple(9).px)};
    position: ${(props) => (props.isRelative ? 'relative' : 'absolute')};
`;
